import { useState } from 'react';
import './StyleCheckbox.css';

function StyleCheckbox({
  active = false,
  id = '',
}) {
  const [isActive, setIsActive] = useState(active);

  const handleClick = () => {
    setIsActive(!isActive);
  };

  return (
    <div className={`style-checkbox ${isActive ? 'active' : 'inactive'}`} onClick={handleClick}>
      <input type="checkbox" id={id} />
    </div>
  );
}

export default StyleCheckbox;
